import React from 'react';

import { useTranslation } from 'react-i18next';

import { Plan } from '@cfa/pathway-fe-shared/xp';

import { itemByLanguage } from '@/utils/language';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

interface RemovePlanProps {
  isLoading?: boolean;
  onRemove: () => void;
  plan: Plan;
  setShowRemovePlan: (show: boolean) => void;
  showRemovePlan: boolean;
}

const RemovePlan: React.FC<RemovePlanProps> = ({
  isLoading,
  onRemove,
  plan,
  setShowRemovePlan,
  showRemovePlan,
}) => {
  const { t } = useTranslation();

  const planName = itemByLanguage(plan.name) ?? '';

  return (
    <ConfirmationModal
      bodyText={t('Settings.removePlanModal.body', { planName })}
      headerText={t('Settings.removePlanModal.title')}
      isOpen={showRemovePlan}
      isDisabled={isLoading}
      isLoading={isLoading}
      onClose={() => setShowRemovePlan(false)}
      primaryButtonHandler={() => {
        onRemove();
      }}
      primaryButtonText={t('Button.remove')}
      primaryButtonVariant="destructive"
      secondaryButtonHandler={() => setShowRemovePlan(false)}
      secondaryButtonText={t('Button.cancel')}
    />
  );
};

export default RemovePlan;
